import styled from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const CreatePersonDialogWrapper = styled.div`
  transition: all 0.2s ease;
  position: fixed;
  overflow: hidden;
  bottom: 0;
  min-width: 312px !important;
  width: calc(30% - 80px);
  height: fit-content;
  transform: none;
  min-width: 200px;
  top: 30%;
  z-index: 101;
  padding: 1em 1.5em 1.5em;
  background: #fff;
  border-radius: 5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: 1400px) {
    width: 40%;
  }

  @media (max-width: 1400px) {
    width: 50%;
  }

  @media (max-width: 767px) {
    width: 80%;
    right: 68px;
  }

  @media (max-width: 599px) {
    width: 80%;
    right: 10%;
  }
`

export const PersonHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PersonHeader = styled.h3`
  text-align: center;
  font-size: 1.3em;
  font-weight: 400;
  margin: 0 0 1.2em;
  line-height: 1.2;
`

export const CloseButton = styled(FontAwesomeIcon)`
  color: #2164db;
  font-size: 1.5em;
  &:hover {
    cursor: pointer;
    color: #0a0a0a;
  }
`

export const ButtonsWrapper = styled.div`
  text-align: right;
  padding: 8px;
`

export const Backdrop = styled.div`
  position: fixed;
  z-index: 100;
  width: 102vw;
  left: -1vw;
  height: 102vh;
  top: -1vh;
  background: #000;
  opacity: 0.8;
`

export const Label = styled.div<{ color: string }>`
  background: ${({ color }) =>
    color === 'error'
      ? 'rgba(219, 1, 0, 0.8)'
      : color === 'warning'
      ? 'rgba(233, 164, 38, 0.8)'
      : color === 'info'
      ? 'rgba(33, 101, 219, 0.8)'
      : color === 'success'
      ? 'rgba(81, 214, 115, 0.8)'
      : 'none'};
  padding: 4px;
  border-radius: 50px;
  height: 28px;
  max-width: 280px;
  margin: 8px 0px;
`

export const SimpleLabel = styled.label`
  font-size: 0.8em;
  font-style: italic;
  font-weight: 100;
`

export const LabelText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.8em;
  text-align: center;
`
